import classNames from "classnames";
import { CSSProperties, ReactNode } from "react";
import useElementOnScreen from "../../../hooks/useElementOnScreen";

const ContentListItem = ({
	children,
	className,
	style,
	...rest
}: {
	children: ReactNode;
	className?: string;
	style?: CSSProperties;
}) => {
	const [containerRef, isVisible] = useElementOnScreen<Element>();
	const hasFadeInFromDirection = /fade-in--from-[^\s]+/.test(className || "");

	return (
		<li
			className={classNames(
				"content-list__item fade-in fade-in--from-left",
				className,
				{
					"fade-in--from-left": !hasFadeInFromDirection,
					visible: isVisible,
				},
			)}
			style={style}
			ref={containerRef as any}
			{...rest}>
			<div className="content-list__item__content-container skip-animation">
				{children}
			</div>
		</li>
	);
};

export default ContentListItem;
